export const DASHBOARD_CLEAR_STORE = "DASHBOARD_CLEAR_STORE";

export const COMPANY_DASHBOARD_START = "COMPANY_DASHBOARD_START";
export const COMPANY_DASHBOARD_SUCCESS = "COMPANY_DASHBOARD_SUCCESS";
export const COMPANY_DASHBOARD_FAIL = "COMPANY_DASHBOARD_FAIL";

export const REALIZATION_DASHBOARD_START = "REALIZATION_DASHBOARD_START";
export const REALIZATION_DASHBOARD_SUCCESS = "REALIZATION_DASHBOARD_SUCCESS";
export const REALIZATION_DASHBOARD_FAIL = "REALIZATION_DASHBOARD_FAIL";

export const ORDER_LIST_SUMMURY_LOAD_START = "ORDER_LIST_SUMMURY_LOAD_START";
export const ORDER_LIST_SUMMURY_LOAD_SUCCESS = "ORDER_LIST_SUMMURY_LOAD_SUCCESS";
export const ORDER_LIST_SUMMURY_LOAD_FAIL = "ORDER_LIST_SUMMURY_LOAD_FAIL";

export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_START = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_START";
export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_SUCCESS = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_SUCCESS";
export const ORDER_LIST_MEDIUM_SUMMURY_LOAD_FAIL = "ORDER_LIST_MEDIUM_SUMMURY_LOAD_FAIL";

export const ORDER_STATUS_LIST_LOAD_START = "ORDER_STATUS_LIST_LOAD_START";
export const ORDER_STATUS_LIST_LOAD_SUCCESS = "ORDER_STATUS_LIST_LOAD_SUCCESS";
export const ORDER_STATUS_LIST_LOAD_FAIL = "ORDER_STATUS_LIST_LOAD_FAIL";

export const TAG_LIST_LOAD_START = "TAG_LIST_LOAD_START";
export const TAG_LIST_LOAD_SUCCESS = "TAG_LIST_LOAD_SUCCESS";
export const TAG_LIST_LOAD_FAIL = "TAG_LIST_LOAD_FAIL";

export const ORDER_COUNT_BY_DAY_LOAD_START = "ORDER_COUNT_BY_DAY_LOAD_START";
export const ORDER_COUNT_BY_DAY_LOAD_SUCCESS = "ORDER_COUNT_BY_DAY_LOAD_SUCCESS";
export const ORDER_COUNT_BY_DAY_LOAD_FAIL = "ORDER_COUNT_BY_DAY_LOAD_FAIL";


export const dashboardFinanceLoadStart = "DASHBOARD_FINANCE_LOAD_START";
export const dashboardFinanceLoadSuccess = "DASHBOARD_FINANCE_LOAD_SUCCESS";
export const dashboardFinanceLoadFail = "DASHBOARD_FINANCE_LOAD_FAIL";

export const dashboardPaymentLoadStart = "DASHBOARD_PAYMENT_LOAD_START";
export const dashboardPaymentLoadSuccess = "DASHBOARD_PAYMENT_LOAD_SUCCESS";
export const dashboardPaymentLoadFail = "DASHBOARD_PAYMENT_LOAD_FAIL";

export const dashboardOrderLoadStart = "DASHBOARD_ORDER_LOAD_START";
export const dashboardOrderLoadSuccess = "DASHBOARD_ORDER_LOAD_SUCCESS";
export const dashboardOrderLoadFail = "DASHBOARD_ORDER_LOAD_FAIL";